import React from 'react'
import { Box, Chip, useTheme } from '@mui/material'
import { getStatusHexColor } from '../utils/statusColors'

interface StatusColumnProps {
  status: string
}

const StatusColumn: React.FC<StatusColumnProps> = ({
  status
}) => {
  const theme = useTheme()
  const isDarkMode = theme.palette.mode === 'dark'





  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        py: 0.5 // Reduced vertical padding for more compact rows
      }}
    >
      {/* Status Chip - Matches Table View exactly */}
      <Chip
        label={status}
        size="small"
        sx={{
          height: 24, // Standard chip height like in Table View
          fontSize: '0.75rem', // Standard font size for better readability
          fontWeight: 500, // Medium weight for clarity
          backgroundColor: getStatusHexColor(status, isDarkMode),
          color: 'white',
          border: 'none',
          '& .MuiChip-label': {
            px: 1, // Standard horizontal padding
            py: 0,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          },
          // Remove any default chip styling that might interfere
          '&:hover': {
            backgroundColor: getStatusHexColor(status, isDarkMode)
          },
          '&:focus': {
            backgroundColor: getStatusHexColor(status, isDarkMode)
          }
        }}
      />
    </Box>
  )
}

export default StatusColumn
